<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          apps
        </mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.eLearning' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <!--      <div class="search-input-wrapper mx-12 m-md-0"-->
      <!--           fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">-->
      <!--        <label for="search" class="mr-8">-->
      <!--          <mat-icon class="secondary-text">search</mat-icon>-->
    <!--        </label>-->

    <!--        &lt;!&ndash; USE IT TO BLOCK CHROME AUTOCOMPLETE &ndash;&gt;-->
    <!--        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">-->
    <!--          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">-->
  <!--        </mat-form-field>-->
  <!--        &lt;!&ndash; USE IT TO BLOCK CHROME AUTOCOMPLETE &ndash;&gt;-->

  <!--        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">-->
  <!--          <mat-label>{{'main.search' | translate}}</mat-label>-->
  <!--          <input id="search" matInput #filter>-->
<!--        </mat-form-field>-->
<!--      </div>-->
<!-- / SEARCH -->
</div>
<!-- / HEADER -->


<!-- CONTENT -->
<div class="content-card mat-white-bg">
  @if (elearnings?.length && !loading) {
    <div class="event-recommendation-page">
      <button class="nav-button left" (click)="scrollCarousel(-1)"
      [disabled]="currentIndex === 0">‹</button>
      <div class="carousel-wrapper">
        <div class="carousel" id="carousel">
          @for (elern of elearnings; track elern; let i = $index) {
            <recommended-elearning [elearning]="elern" [index]="i" (deleteElearning)="deleteElearnings($event)"></recommended-elearning>
          }
        </div>
      </div>
      <button class="nav-button right" (click)="scrollCarousel(1)"
      [disabled]="currentIndex === elearnings.length - 1">›</button>
    </div>
  }
  @if (!elearnings?.length && !loading) {
    <div class="no-data">
      {{'no_data' | translate}}
    </div>
  }
</div>
<!-- / CONTENT -->

</div>
</div>



